import { IonBadge, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonLabel, IonLoading, IonMenuButton, IonModal, IonPage, IonRow, IonTextarea, IonTitle, IonToast, IonToolbar, useIonViewDidEnter } from '@ionic/react';
import { appsOutline, arrowBack, calendarOutline, chatbubbles, chatbubblesOutline, clipboardOutline, copy, desktopOutline, flagOutline, lockClosedOutline, notifications, trendingUpOutline } from 'ionicons/icons';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Autoplay, Navigation, Pagination, Swiper as SwiperInterface } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import '@ionic/react/css/ionic-swiper.css';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import { MessageContext } from '../../../../../contexts/MessageContext';
import { getPlanos, pagamentoMensalidade, usuariosAlterarPin } from '../../../../../Utils/Services';
import Menu from '../../Components/Menu';
import Notificacoes from '../Notificacoes/Notificacoes';
import './Inicio.css';
import PINInput from './PINInput';


type Props = {
  abrirMenu: boolean;
};

const Inicio: React.FC<Props> = (props: Props) => {
  const history = useHistory();
  const [showLoadingPage, setShowLoadingPage] = useState(false);

  const { loja, setLoja } = useContext(MessageContext);

  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);

  const { notificacoes, setNotificacoes } = useContext(MessageContext);
  const [showNotificacoes, setShowNotificacoes] = useState(false);

  const { mensagens, setMensagens } = useContext(MessageContext);

  const [swiperInstance, setSwiperInstance] = useState<SwiperInterface>();

  const [showModalPlanos, setShowModalPlanos] = useState(false);
  const [planos, setPlanos] = useState<any[]>([]);
  const [loadingPlanos, setLoadingPlanos] = useState(false);
  const [showModalQrCode, setShowModalQrCode] = useState(false);
  const [qrCodeData, setQRCodeData] = useState<any>();
  const [qrCode, setQRCode] = useState<any>();
  const { idPagamento, setIdPagamento } = useContext(MessageContext);
  const { isPaymentCompleted, setIsPaymentCompleted } = useContext(MessageContext);
  const [valorPagamento, setValorPagamento] = useState<any>();

  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");

  const { dadosEmpresa, setDadosEmpresa } = useContext(MessageContext);

  const [timeLeft, setTimeLeft] = useState(6 * 60);

  // Estados para o modal de PIN
  const [showModalPin, setShowModalPin] = useState(false);
  const [pin, setPin] = useState(['', '', '', '']);
  const [confirmPin, setConfirmPin] = useState(['', '', '', '']);
  const [etapaPin, setEtapaPin] = useState(1); // 1 = criar PIN, 2 = confirmar PIN
  const [erroPin, setErroPin] = useState(false);

  useIonViewDidEnter(() => {
    setEsconderMenu(false);
    setNomeMenu("");

    // Verifica se a senha foi cadastrada
    const pinCadastrado = window.localStorage.getItem("pinCadastrado");
    if (pinCadastrado && pinCadastrado === "true") {
      console.log("PIN já cadastrado");
    } else {
      setShowModalPin(true);
    }
  });

  async function carregarPlanos() {
    setLoadingPlanos(true);
    try {
      var token: string = "";
      var tkn = localStorage.getItem("token");
      if (typeof (tkn) === "string") { token = tkn; }

      let resp = await fetch(getPlanos.url, {
        method: getPlanos.method,
        headers: [
          ["token", token]
        ],
        credentials: 'include'
      });
      let retorno = await resp.json();

      if (resp.status === 200 && retorno.planos) {
        setPlanos(retorno.planos);
      } else {
        setTextToast("Erro ao carregar planos. Tente novamente.");
        setShowToast(true);
      }
    } catch (error) {
      console.error("Erro ao carregar planos:", error);
      setTextToast("Erro ao carregar planos. Tente novamente.");
      setShowToast(true);
    } finally {
      setLoadingPlanos(false);
    }
  }

  async function closeModalNotificacoes() {
    setShowNotificacoes(false);
  }

  async function closeModalSimpleNotificacoes() {
    setShowNotificacoes(false);
  }

  // Função utilitária para verificar se o PIN é sequencial
  function isSequencial(pinArray: string[]) {
    if (pinArray.length < 2) return false;
    let isAsc = true;
    let isDesc = true;
    for (let i = 1; i < pinArray.length; i++) {
      const prev = parseInt(pinArray[i - 1], 10);
      const curr = parseInt(pinArray[i], 10);
      if (isNaN(prev) || isNaN(curr)) return false;
      if (curr !== prev + 1) isAsc = false;
      if (curr !== prev - 1) isDesc = false;
    }
    return isAsc || isDesc;
  }

  // Função utilitária para verificar se há mais de 3 dígitos iguais
  function hasMoreThan3Equal(pinArray: string[]) {
    let count = 1;
    for (let i = 1; i < pinArray.length; i++) {
      if (pinArray[i] === pinArray[i - 1]) {
        count++;
        if (count > 3) return true;
      } else {
        count = 1;
      }
    }
    return false;
  }

  const avancarParaConfirmacao = () => {
    const pinCompleto = pin.every(digit => digit !== '');

    if (!pinCompleto) {
      setTextToast("Por favor, preencha todos os 4 dígitos do PIN.");
      setShowToast(true);
      return;
    }

    if (isSequencial(pin)) {
      setTextToast("O PIN não pode ser sequencial.");
      setShowToast(true);
      return;
    }

    if (hasMoreThan3Equal(pin)) {
      setTextToast("O PIN não pode ter mais de 3 dígitos iguais em sequência.");
      setShowToast(true);
      return;
    }

    setEtapaPin(2);
    // Foca no primeiro campo de confirmação
    setTimeout(() => {
      const firstInput = document.getElementById('confirm-pin-input-0');
      if (firstInput) (firstInput as HTMLInputElement).focus();
    }, 100);
  };

  // Função para salvar o PIN
  const salvarPin = async () => {
    const pinCompleto = confirmPin.every(digit => digit !== '');

    if (!pinCompleto) {
      setTextToast("Por favor, preencha todos os 4 dígitos de confirmação.");
      setShowToast(true);
      return;
    }

    const pinString = pin.join('');
    const confirmPinString = confirmPin.join('');

    if (pinString !== confirmPinString) {
      setTextToast("Os PINs não conferem. Tente novamente.");
      setShowToast(true);
      setErroPin(true);
      setConfirmPin(['', '', '', '']);
      setTimeout(() => setErroPin(false), 500);
      // Foca no primeiro campo de confirmação
      setTimeout(() => {
        const firstInput = document.getElementById('confirm-pin-input-0');
        if (firstInput) (firstInput as HTMLInputElement).focus();
      }, 100);
      return;
    }

    // Chamada à API para alterar o PIN
    try {
      setShowLoadingPage(true);

      // Monta o objeto para envio
      const objeto = {
        pk: loja,
        pin: pinString
      };

      // Endpoint de alteração de PIN
      // usuariosAlterarPin deve estar importado de Services
      const resp = await fetch(
        usuariosAlterarPin.url.replace("{pk}", btoa(objeto.pk)),
        {
          method: usuariosAlterarPin.method,
          headers: [["token", localStorage.getItem("token") || ""]],
          credentials: 'include',
          body: JSON.stringify(objeto)
        }
      );
      if (resp.status === 200) {
        window.localStorage.setItem("pinCadastrado", "true");
        setTextToast("PIN cadastrado com sucesso! Use-o no próximo acesso.");
        setShowToast(true);
        setShowModalPin(false);
      } else {
        setTextToast("Erro ao cadastrar PIN. Tente novamente.");
        setShowToast(true);
      }
    } catch (error) {
      console.error("Erro ao salvar PIN:", error);
      setTextToast("Erro ao cadastrar PIN. Tente novamente.");
      setShowToast(true);
    } finally {
      setShowLoadingPage(false);
    }
  };

  // Função para voltar para a etapa de criação
  const voltarParaCriacao = () => {
    setEtapaPin(1);
    setConfirmPin(['', '', '', '']);
    // Foca no primeiro campo
    setTimeout(() => {
      const firstInput = document.getElementById('pin-input-0');
      if (firstInput) (firstInput as HTMLInputElement).focus();
    }, 100);
  };

  useEffect(() => {
    if (isPaymentCompleted && showModalQrCode) {
      setShowModalQrCode(false);
      setIsPaymentCompleted(false);
    }
  }, [isPaymentCompleted]);

  // Foca no primeiro campo quando o modal abre em modo validação
  useEffect(() => {
    if (showModalPin) {
      setTimeout(() => {
        const firstInput = document.getElementById('pin-validacao-input-0');
        if (firstInput) (firstInput as HTMLInputElement).focus();
      }, 300);
    }
  }, [showModalPin]);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (showModalQrCode) {
      setTimeLeft(6 * 60);

      timer = setInterval(() => {
        setTimeLeft(prevTime => {
          if (prevTime > 0) {
            return prevTime - 1;
          } else {
            clearInterval(timer);
            handleQrCodeExpired();
            return 0;
          }
        });
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [showModalQrCode]);

  const handleQrCodeExpired = () => {
    setTextToast("Código expirado. Gere um novo para efetuar o pagamento.");
    setShowToast(true);
    setShowModalQrCode(false);
  };

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  return (
    <>
      <Menu id="main-content-inicio"></Menu>
      <IonPage id="main-content-inicio" className="Inicio">
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonMenuButton></IonMenuButton>
            </IonButtons>

            <IonButtons slot="end">
              <IonButton onClick={() => { setShowNotificacoes(true); }}>
                <IonIcon slot="icon-only" icon={notifications} />
                <IonBadge id="cart-badge" color="danger">{notificacoes?.length}</IonBadge>
              </IonButton>
            </IonButtons>

            <IonButtons slot="end" hidden={acessos?.chat != 'leitura' && acessos?.chat != 'edicao'}>
              <IonButton onClick={() => { history.push("./chat"); }}>
                <IonIcon slot="icon-only" icon={chatbubbles} />
                <IonBadge id="cart-badge" color="danger">{mensagens?.length}</IonBadge>
              </IonButton>
            </IonButtons>
          </IonToolbar>

          {dadosEmpresa && Object.keys(dadosEmpresa).length > 0 && (
            <IonToolbar color="light" hidden={dadosEmpresa.tempoRestanteParaPagamento > 20 || dadosEmpresa.pk != dadosEmpresa.gsi3pk}>
              <IonGrid>
                <IonRow class="ion-align-items-center">
                  <IonCol size="auto">
                    <IonLabel>
                      {(dadosEmpresa.bloquearAcesso) ?
                        (
                          <strong>Seu acesso foi bloqueado. Realize o pagamento para continuar utilizando nossos serviços.</strong>
                        )
                        : (
                          <strong>
                            {(dadosEmpresa.tempoRestanteParaPagamento || 0) === 0
                              ? "Amanhã seu acesso será bloqueado. Realize o pagamento para manter o acesso."
                              : (dadosEmpresa.tempoRestanteParaPagamento === 1
                                ? `Falta 1 dia para o vencimento da sua licença. Realize o pagamento para manter o acesso.`
                                : `Faltam ${dadosEmpresa.tempoRestanteParaPagamento || 0} dias para o vencimento da sua licença. ${dadosEmpresa.tempoRestanteParaPagamento <= 10
                                  ? "Realize o pagamento para manter o acesso."
                                  : "Garanta o próximo mês."
                                }`)
                            }
                          </strong>
                        )
                      }
                    </IonLabel>
                  </IonCol>
                  <IonCol class="ion-text-right">
                    <IonButton color="danger" size="small" onClick={async () => {
                      await carregarPlanos();
                      setShowModalPlanos(true);
                    }}>
                      Realizar Pagamento
                    </IonButton>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </IonToolbar>
          )}
        </IonHeader>
        <IonContent fullscreen={false}>
          <div style={{ padding: '5px' }}>
            <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '0px', paddingBottom: '0px' }}>
              <div id='containerInicioCategorias' style={{ maxWidth: '1024px' }}>
                <IonGrid fixed={true} style={{ paddingTop: '12px', maxWidth: "690px" }}>
                  <IonRow>
                    <IonCol size={"6"} size-md={"6"} size-lg={"6"} hidden={(acessos?.vendas != 'leitura' && acessos?.vendas != 'edicao')}>
                      <IonCard onClick={() => { history.push("./vendas") }} style={{ width: '100%', maxWidth: '100%', height: "134px" }} disabled={dadosEmpresa.bloquearAcesso} >
                        <IonCardHeader style={{ paddingTop: '14px', paddingBottom: '0px' }}>
                          <IonIcon color='primary' style={{ border: '1px solid #ccc', borderRadius: '10px', padding: '10px' }} icon={trendingUpOutline} />
                          <IonCardTitle style={{ fontSize: "16px", fontWeight: 'bold' }}>Vendas</IonCardTitle>
                        </IonCardHeader>
                        <IonCardContent style={{ fontSize: "12px" }}>
                          Funil de vendas e orçamentos
                        </IonCardContent>
                      </IonCard>
                    </IonCol>

                    <IonCol size={"6"} size-md={"6"} size-lg={"6"} hidden={(acessos?.balcao != 'leitura' && acessos?.balcao != 'edicao')}>
                      <IonCard onClick={() => { history.push("./caixa") }} style={{ width: '100%', maxWidth: '100%', height: "134px" }} disabled={dadosEmpresa.bloquearAcesso}>
                        <IonCardHeader style={{ paddingTop: '14px', paddingBottom: '0px' }}>
                          <IonIcon color='primary' style={{ border: '1px solid #ccc', borderRadius: '10px', padding: '10px' }} icon={desktopOutline} />
                          <IonCardTitle style={{ fontSize: "16px", fontWeight: 'bold' }}>{"Balcão"} </IonCardTitle>
                        </IonCardHeader>
                        <IonCardContent style={{ fontSize: "12px" }}>
                          PDV
                        </IonCardContent>
                      </IonCard>
                    </IonCol>

                    <IonCol size={"6"} size-md={"6"} size-lg={"6"} hidden={(acessos?.comandas != 'leitura' && acessos?.comandas != 'edicao')}>
                      <IonCard onClick={() => { history.push("./comandas") }} style={{ width: '100%', maxWidth: '100%', height: "134px" }} disabled={dadosEmpresa.bloquearAcesso}>
                        <IonCardHeader style={{ paddingTop: '14px', paddingBottom: '0px' }}>
                          <IonIcon color='primary' style={{ border: '1px solid #ccc', borderRadius: '10px', padding: '10px' }} icon={clipboardOutline} />
                          <IonCardTitle style={{ fontSize: "16px", fontWeight: 'bold' }}>{window.localStorage.getItem("nomeInternoMesasOuComandas") || "Mesas"}</IonCardTitle>
                        </IonCardHeader>
                        <IonCardContent style={{ fontSize: "12px" }}>
                          Efetue {window.localStorage.getItem("servicoTipo") || "Projeto"} diretamente nas {window.localStorage.getItem("nomeInternoMesasOuComandas") || "Mesas"}
                        </IonCardContent>
                      </IonCard>
                    </IonCol>

                    <IonCol size={"6"} size-md={"6"} size-lg={"6"} hidden={(acessos?.projetos != 'leitura' && acessos?.projetos != 'edicao')}>
                      <IonCard onClick={() => { history.push("./ordens") }} style={{ width: '100%', maxWidth: '100%', height: "134px" }} disabled={dadosEmpresa.bloquearAcesso}>
                        <IonCardHeader style={{ paddingTop: '14px', paddingBottom: '0px' }}>
                          <IonIcon color='primary' style={{ border: '1px solid #ccc', borderRadius: '10px', padding: '10px' }} icon={appsOutline} />
                          <IonCardTitle style={{ fontSize: "16px", fontWeight: 'bold' }}>{window.localStorage.getItem("servicoTipoPlural") || "Projetos"}</IonCardTitle>
                        </IonCardHeader>
                        <IonCardContent style={{ fontSize: "12px" }}>
                          Crie e acompanhe {window.localStorage.getItem("servicoTipoPlural") || "Projetos"}
                        </IonCardContent>
                      </IonCard>
                    </IonCol>

                    <IonCol size={"6"} size-md={"6"} size-lg={"6"} hidden={(acessos?.agenda != 'leitura' && acessos?.agenda != 'edicao')}>
                      <IonCard onClick={() => { history.push("./agendamentoseventoscommenu") }} style={{ width: '100%', maxWidth: '100%', height: "134px" }} disabled={dadosEmpresa.bloquearAcesso}>
                        <IonCardHeader style={{ paddingTop: '14px', paddingBottom: '0px' }}>
                          <IonIcon color='primary' style={{ border: '1px solid #ccc', borderRadius: '10px', padding: '10px' }} icon={calendarOutline} />
                          <IonCardTitle style={{ fontSize: "16px", fontWeight: 'bold' }}>Agenda</IonCardTitle>
                        </IonCardHeader>
                        <IonCardContent style={{ fontSize: "12px" }}>
                          Agende entregas, serviços e reuniões
                        </IonCardContent>
                      </IonCard>
                    </IonCol>

                    <IonCol size={"6"} size-md={"6"} size-lg={"6"} hidden={(acessos?.operacoes != 'leitura' && acessos?.operacoes != 'edicao')}>
                      <IonCard onClick={() => { history.push("./operacoes") }} style={{ width: '100%', maxWidth: '100%', height: "134px" }} disabled={dadosEmpresa.bloquearAcesso}>
                        <IonCardHeader style={{ paddingTop: '14px', paddingBottom: '0px' }}>
                          <IonIcon color='primary' style={{ border: '1px solid #ccc', borderRadius: '10px', padding: '10px' }} icon={flagOutline} />
                          <IonCardTitle style={{ fontSize: "16px", fontWeight: 'bold' }}>Operações</IonCardTitle>
                        </IonCardHeader>
                        <IonCardContent style={{ fontSize: "12px" }}>
                          Acompanhe o dia a dia da equipe
                        </IonCardContent>
                      </IonCard>
                    </IonCol>

                    <IonCol size={"6"} size-md={"6"} size-lg={"6"}>
                      <a target='_blank' href={"https://api.whatsapp.com/send?phone=5511963927646"} style={{ textDecoration: 'none' }}>
                        <IonCard style={{ width: '100%', maxWidth: '100%', height: "134px" }}>
                          <IonCardHeader style={{ paddingTop: '14px', paddingBottom: '0px' }}>
                            <IonIcon color="primary" style={{ border: '1px solid #ccc', borderRadius: '10px', padding: '10px' }} icon={chatbubblesOutline} />
                            <IonCardTitle style={{ fontSize: "16px", fontWeight: 'bold' }}>Ajuda</IonCardTitle>
                          </IonCardHeader>
                          <IonCardContent style={{ fontSize: "12px" }}>
                            Como podemos ajudar você?
                          </IonCardContent>
                        </IonCard>
                      </a>
                    </IonCol>
                  </IonRow>
                </IonGrid>
              </div>
            </div>

            <IonGrid fixed={true} style={{ paddingTop: '0px', paddingBottom: '10px', paddingLeft: '18px', paddingRight: '18px' }}>
              <IonRow>
                <IonCol size={"12"} size-md={"12"} size-lg={"12"} style={{ padding: '0px' }}>
                  <Swiper
                    spaceBetween={30}
                    centeredSlides={true}
                    autoplay={{
                      delay: 5000,
                      disableOnInteraction: false,
                    }}
                    pagination={{
                      clickable: true
                    }}
                    navigation={false}
                    modules={[Autoplay, Pagination, Navigation]}
                    onSwiper={(swiper) => {
                      setSwiperInstance(swiper);
                    }} >
                    <div>
                      <SwiperSlide>
                        <img src="https://xeguei-plt-welcome.s3.sa-east-1.amazonaws.com/banners/banner1.png" alt="Banner 1" />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img src="https://xeguei-plt-welcome.s3.sa-east-1.amazonaws.com/banners/banner2.png" alt="Banner 2" />
                      </SwiperSlide>
                    </div>
                  </Swiper>
                </IonCol>
              </IonRow>
            </IonGrid>
          </div>

          <div className="content">
            {/* Modal de Cadastro de PIN */}
            <IonModal
              isOpen={showModalPin}
              backdropDismiss={false}
              onDidDismiss={() => setShowModalPin(false)}
            >
              <IonHeader>
                <IonToolbar color="primary">
                  {etapaPin === 2 && (
                    <IonButtons slot="start">
                      <IonButton onClick={voltarParaCriacao}>
                        <IonIcon slot="icon-only" icon={arrowBack} />
                      </IonButton>
                    </IonButtons>
                  )}
                  <IonTitle>
                    {(etapaPin === 1 ? "Criar PIN de Acesso" : "Confirmar PIN")}
                  </IonTitle>
                </IonToolbar>
              </IonHeader>

              <IonContent className="ion-padding">
                <IonGrid>
                  <IonRow className="ion-justify-content-center ion-margin-top">
                    <IonCol size="12" sizeMd="8" sizeLg="6">

                      <div style={{ textAlign: "center", marginBottom: "20px" }}>
                        <IonIcon
                          icon={lockClosedOutline}
                          style={{ fontSize: "40px", color: "var(--ion-color-primary)" }}
                        />
                      </div>

                      {etapaPin === 1 && (
                        <>
                          <IonLabel>
                            <h2 style={{ textAlign: "center", marginBottom: "10px" }}>
                              <strong>Configure seu PIN</strong>
                            </h2>
                            <p
                              style={{
                                textAlign: "center",
                                color: "var(--ion-color-medium)",
                                marginBottom: "20px",
                              }}
                            >
                              Crie um PIN de 4 dígitos para facilitar seu próximo acesso ao
                              sistema.
                            </p>
                          </IonLabel>

                          <PINInput
                            length={4}
                            onChange={(pinDigitado: any) => {
                              const pinArray = pinDigitado.split("");
                              while (pinArray.length < 4) {
                                pinArray.push("");
                              }
                              setPin(pinArray.slice(0, 4));
                            }}
                            onComplete={(pinDigitado: any) => {
                              setPin(pinDigitado.split(""));
                            }}
                          />

                          <IonButton
                            expand="block"
                            onClick={() => {
                              if (!pin.every(digit => digit !== '')) {
                                setTextToast("Por favor, preencha todos os 4 dígitos do PIN.");
                                setShowToast(true);
                                return;
                              }
                              avancarParaConfirmacao();
                            }}
                            style={{ marginTop: '20px' }}
                          >
                            Avançar
                          </IonButton>

                        </>
                      )}

                      {etapaPin === 2 && (
                        <>
                          <IonLabel>
                            <h2 style={{ textAlign: "center", marginBottom: "10px" }}>
                              <strong>Confirme seu PIN</strong>
                            </h2>
                            <p
                              style={{
                                textAlign: "center",
                                color: "var(--ion-color-medium)",
                                marginBottom: "20px",
                              }}
                            >
                              Digite novamente o PIN para confirmar.
                            </p>
                          </IonLabel>

                          <PINInput
                            length={4}
                            error={erroPin}
                            onChange={(confirmado: any) => {
                              const pinArray = confirmado.split("");
                              while (pinArray.length < 4) {
                                pinArray.push("");
                              }
                              setConfirmPin(pinArray.slice(0, 4));
                            }}
                            onComplete={(confirmado: any) => {
                              setConfirmPin(confirmado.split(""));
                            }}
                          />

                          <IonButton
                            expand="block"
                            onClick={() => {
                              if (!confirmPin.every(digit => digit !== '')) {
                                setTextToast("Por favor, preencha todos os 4 dígitos de confirmação.");
                                setShowToast(true);
                                return;
                              }
                              salvarPin();
                            }}
                            style={{ marginTop: '20px' }}
                          >
                            Salvar
                          </IonButton>
                        </>
                      )}

                      <div
                        style={{
                          marginTop: "20px",
                          padding: "15px",
                          backgroundColor: "#f0f9ff",
                          borderRadius: "10px",
                          border: "1px solid #bfdbfe",
                        }}
                      >
                        <IonLabel>
                          <p
                            style={{
                              fontSize: "12px",
                              color: "var(--ion-color-medium)",
                              margin: 0,
                            }}
                          >
                            <strong>💡 Dica:</strong> Escolha um PIN fácil de lembrar. Ele
                            será usado para acessos rápidos ao sistema.
                          </p>
                        </IonLabel>
                      </div>
                    </IonCol>
                  </IonRow>
                </IonGrid>
              </IonContent>
            </IonModal>


            <IonModal className="fullscreen-modal" isOpen={showModalPlanos} onDidDismiss={() => setShowModalPlanos(false)}>
              <IonHeader>
                <IonToolbar color="primary">
                  <IonButtons slot="start">
                    <IonIcon slot="icon-only" icon={arrowBack} onClick={() => setShowModalPlanos(false)} />
                  </IonButtons>
                  <IonTitle>Escolha seu plano</IonTitle>
                </IonToolbar>
              </IonHeader>
              <IonContent className="ion-padding">
                {loadingPlanos ? (
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <IonLoading isOpen={loadingPlanos} message="Carregando planos..." />
                  </div>
                ) : (
                  <IonGrid>
                    <IonRow>
                      {planos.map((plano: any) => (
                        <IonCol key={plano.id} size="12" sizeMd="4">
                          <IonCard style={{
                            ...(plano.destaque ? { border: '2px solid var(--ion-color-primary)' } : {}),
                            position: 'relative',
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column'
                          }}>
                            {plano.destaque && (
                              <div style={{
                                position: 'absolute',
                                top: '12px',
                                right: '12px',
                                backgroundColor: 'var(--ion-color-primary)',
                                color: '#fff',
                                padding: '4px 12px',
                                borderRadius: '12px',
                                fontSize: '12px',
                                fontWeight: 'bold',
                                textTransform: 'uppercase',
                                zIndex: 10
                              }}>
                                Recomendado
                              </div>
                            )}
                            <IonCardHeader style={{ flex: '0 0 auto' }}>
                              <IonCardTitle style={{ paddingRight: plano.destaque ? '110px' : '0' }}>
                                {plano.titulo}
                              </IonCardTitle>
                              {plano.subtitulo && (
                                <p style={{ fontSize: '14px', color: 'var(--ion-color-medium)', marginTop: '4px', marginBottom: '12px' }}>
                                  {plano.subtitulo}
                                </p>
                              )}

                              {/* Preço e condições logo após o subtítulo */}
                              {plano.valorFormatado && (
                                <p style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '8px', marginTop: '8px' }}>
                                  {plano.valorFormatado}
                                  {plano.recorrencia && <span style={{ fontSize: '16px', fontWeight: 'normal' }}> /{plano.recorrencia}</span>}
                                </p>
                              )}

                              {plano.percentualDescontoFormatado && (
                                <p style={{ fontSize: '14px', color: 'var(--ion-color-success)', marginBottom: '0px', fontWeight: 'bold' }}>
                                  {plano.percentualDesconto && plano.percentualDesconto > 0
                                    ? `Desconto de ${plano.percentualDescontoFormatado} na mensalidade!!!`
                                    : <span>
                                      Quer pagar menos? Garanta seu desconto {' '}
                                      <a
                                        href="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          window.open("https://api.whatsapp.com/send?phone=5511963927646&text=Gostaria de obter meu desconto na mensalidade do xeguei", "_blank");
                                        }}
                                        style={{ color: 'var(--ion-color-success)', textDecoration: 'underline' }}
                                      >
                                        aqui!
                                      </a>
                                    </span>
                                  }
                                </p>
                              )}
                            </IonCardHeader>
                            <IonCardContent style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                              <div style={{ flex: '1' }}>
                                {plano.descricao && (
                                  <p style={{ marginBottom: '12px' }}>{plano.descricao}</p>
                                )}

                                {plano.recursos && plano.recursos.length > 0 && (
                                  <ul style={{ paddingLeft: '20px', marginBottom: '16px' }}>
                                    {plano.recursos.map((recurso: string, index: number) => (
                                      <li key={index} style={{ marginBottom: '8px' }}>{recurso}</li>
                                    ))}
                                  </ul>
                                )}
                              </div>

                              <div style={{ marginTop: 'auto' }}>
                                {plano.mensagemContato && (
                                  <p style={{
                                    fontSize: '14px',
                                    color: 'var(--ion-color-medium)',
                                    backgroundColor: '#f5f5f5',
                                    padding: '12px',
                                    borderRadius: '8px',
                                    marginBottom: '16px',
                                    fontStyle: 'italic'
                                  }}>
                                    {plano.mensagemContato}
                                  </p>
                                )}

                                <IonButton
                                  expand="block"
                                  color={plano.destaque ? "primary" : "secondary"}
                                  style={{ marginTop: '20px' }}
                                  onClick={async () => {
                                    // Se o plano tem contemContato, abre WhatsApp ao invés de processar pagamento
                                    if (plano.contemContato) {
                                      window.open("https://api.whatsapp.com/send?phone=5511963927646&text=Olá! Gostaria de saber mais sobre o plano Multi Lojas.", "_blank");
                                      return;
                                    }

                                    var token: string = "";
                                    var tkn = localStorage.getItem("token");
                                    if (typeof (tkn) === "string") { token = tkn; }

                                    const objectRequest = plano.tipo ? {
                                      compra: plano.tipo
                                    } : undefined;

                                    let resp = await fetch(
                                      pagamentoMensalidade.url.replace("{id}", loja.replaceAll(/#/g, "%23")),
                                      {
                                        method: pagamentoMensalidade.method,
                                        headers: [
                                          ["token", token]
                                        ],
                                        body: objectRequest ? JSON.stringify(objectRequest) : undefined,
                                        credentials: 'include'
                                      }
                                    );
                                    let retorno = await resp.json();

                                    if (resp.status === 400 || resp.status === 401) {
                                      setTextToast("Ocorreu um erro ao gerar o Pagamento, entre em contato com o suporte.");
                                      setShowToast(true);
                                    }
                                    else {
                                      if (retorno.message) {
                                        setIdPagamento(retorno.message.id);
                                        setQRCode(retorno.message.point_of_interaction.transaction_data.qr_code);
                                        setQRCodeData(retorno.message.point_of_interaction.transaction_data.qr_code_base64);
                                        setValorPagamento(retorno.message.transaction_amount);
                                        setShowModalPlanos(false);
                                        setShowModalQrCode(true);
                                      }
                                      else {
                                        setTextToast("Ocorreu um erro ao gerar o Pagamento, entre em contato com o suporte.");
                                        setShowToast(true);
                                      }
                                    }
                                  }}
                                >
                                  {plano.contemContato ? 'Falar com especialista' : 'Selecionar'}
                                </IonButton>
                              </div>
                            </IonCardContent>
                          </IonCard>
                        </IonCol>
                      ))}
                    </IonRow>
                  </IonGrid>
                )}
              </IonContent>
            </IonModal>

            <IonModal className="fullscreen-modal" isOpen={showModalQrCode} onDidDismiss={() => {
              setShowModalQrCode(false);
              // Limpa o idPagamento para parar o polling
              setIdPagamento("");
            }}>
              <IonHeader>
                <IonToolbar color="primary">
                  <IonButtons slot="start">
                    <IonIcon slot="icon-only" icon={arrowBack} onClick={() => {
                      setShowModalQrCode(false);
                      setShowModalPlanos(true);
                      // Limpa o idPagamento para parar o polling
                      setIdPagamento("");
                    }} />
                  </IonButtons>
                  <IonTitle>Detalhes do pagamento</IonTitle>
                </IonToolbar>
              </IonHeader>
              <IonContent>




                <IonCard className="div-qrcode-pagamento">
                  <IonCardContent>

                    {/* Título Assinatura */}
                    <IonLabel className="qr-code-pagamento">
                      <h2><b>Assinatura XEGUEI</b></h2>
                    </IonLabel>

                    {/* Valor do pagamento */}
                    <IonLabel>
                      <p className="payment-title">Pague <b>R$ {valorPagamento?.toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}</b> via <b>Pix</b></p>
                    </IonLabel>

                    {/* Informações de vencimento */}
                    {/* <IonLabel>
                      <p className="payment-info">Vencimento: 30 minutos</p>
                    </IonLabel> */}

                    {/* Texto explicativo */}
                    <IonLabel className="qr-code-pagamento-margin">
                      <h3>Para pagar, escolha uma destas opções:</h3>
                    </IonLabel>

                    {/* Código QR */}
                    <IonCardContent className="qr-code-pagamento">
                      <IonLabel>
                        <p>Código QR</p>
                      </IonLabel>
                      {qrCodeData && <img src={`data:image/png;base64,${qrCodeData}`} alt="QR Code" />}
                    </IonCardContent>

                    {/* Código de pagamento e botão de cópia */}
                    <IonCardContent className="qr-code-pagamento">
                      <IonLabel>
                        <p>Código de pagamento</p>
                      </IonLabel>
                      <div className="copy-code-container">
                        {/* Substituído por IonTextarea */}
                        <IonTextarea
                          readonly={true}
                          style={{ "--background": "#eeeeee" }}
                          rows={2}
                          value={qrCode}
                        />
                        <IonButton fill="clear" onClick={() => {
                          navigator.clipboard.writeText(qrCode);
                          setTextToast("Código copiado");
                          setShowToast(true);
                        }}>
                          <IonIcon color="primary" icon={copy} />
                        </IonButton>
                      </div>

                    </IonCardContent>


                    <IonLabel className="qr-code-pagamento">
                      Código válido por: <h1>{minutes}:{seconds < 10 ? `0${seconds}` : seconds}</h1>
                    </IonLabel>
                    {/* Instruções de como pagar */}
                    <IonCardContent>

                      <IonLabel>
                        <p><b>Como pagar?</b></p>
                        <ol>
                          <li>Entre no app ou site do seu banco e escolha a opção de pagamento via Pix.</li>
                          <li>Escaneie o código QR ou copie e cole o código de pagamento.</li>
                          <li>Pronto! Agora é só aguardar o pagamento ser processado.</li>
                        </ol>
                      </IonLabel>
                    </IonCardContent>


                  </IonCardContent>
                </IonCard>








              </IonContent>

            </IonModal>

            <IonModal isOpen={showNotificacoes} onDidDismiss={() => { setShowNotificacoes(false); }}>
              <Notificacoes closeAction={closeModalNotificacoes} closeActionSimple={closeModalSimpleNotificacoes}></Notificacoes>
            </IonModal>

          </div >


          <IonToast
            isOpen={showToast}
            position="middle" //top, bottom, middle
            onDidDismiss={() => setShowToast(false)}
            message={textToast}
            duration={3000}
          />

          <IonLoading
            cssClass='my-custom-class'
            isOpen={showLoadingPage}
            onDidDismiss={() => { setShowLoadingPage(false); }}
            spinner='circles'
          />
        </IonContent >
      </IonPage >
    </>
  );
};

export default Inicio;